export const HOST = '';
export const SPA_ENDPOINT = '/spa/api';
export const API_ENDPOINT = '/api';
export const NEW_EXTERNAL_API_ENDPOINT = '/api/cabinet/external'
